import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { DialogTitle, Avatar } from '@mui/material';
import StatusAdmin from '../../utils/status/statusAdmin';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../../load/loading';
import api from '../../services/api';
import RegisterAccess from '../../utils/registerAccess';

const useStyles = (theme) => ({
    fundo: {
        minHeight: '70vh',
        backgroundImage: 'url(/img/logo/logoArmed.svg)',
        backgroundSize: 'cover',
        // backgroundPosition: 'end',
        opacity: 0.1,
        // position: 'absolute',
        width: '100%',
        padding: 40
    },

    altura: { minHeight: '70vh' }
});


function SimpleDialog(props) {
    const { open } = props;
    // const handleClose = () => { onClose('') };
    const navigate = useNavigate()

    return (
        <Dialog fullWidth open={open} scroll='body' >
            {props.admin?.dadosPessoais &&
                <DialogTitle mb={2}>
                    <Button color='error' title="fechar" style={{ position: 'absolute', right: 5, fontWeight: 'bold' }} onClick={() => navigate('/')}> <CloseIcon /></Button>
                </DialogTitle>
            }

            {props.admin?.dadosPessoais ?
                <>
                    <div style={{ height: '50vh', display: 'flex', justifyContent: 'center', padding: 10 }}>
                        <Avatar style={{ borderRadius: 5, width: '100%', height: '100%' }} src={props.admin?.dadosPessoais.fotoURL} alt={props.admin?.dadosPessoais.nome} />
                    </div>

                    <Typography style={{ lineHeight: 1, margin: 5, fontSize: 25, fontWeight: 'bold' }} align="center" variant="h1">
                        {props.admin?.dadosPessoais.nome}
                    </Typography>

                    {/* <Typography style={{ lineHeight: 1.5, margin: 10 }} align="center" variant="body1">
                        {' Nº de Agente: ' + props.admin?.numeroAgente}
                    </Typography> */}

                    <StatusAdmin status={props.admin?.status} />
                </>
                :
                <div style={{ padding: 20 }}>
                    <Typography style={{ lineHeight: 1 }} align="center" variant="subtitle1">
                        Técnico não licenciado pela ARMED
                    </Typography>

                    <Button style={{ marginTop: 20 }} size='small' fullWidth color='error' onClick={() => navigate('/')}>Fechar</Button>
                </div>
            }
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function ConsultaTecnico() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [admin, setadmin] = React.useState('');
    const handleClose = () => { setOpen(false) };
    const { idTecnico } = useParams()

    React.useEffect(() => {
        api.get(`/admin/${idTecnico}`)
            .then(response => {
                // console.log(response)
                setadmin(response.data.admin);
                setOpen(true)
            }).catch(err => {
                // console.log(err)
                setOpen(true)
            })
    }, [idTecnico])

    return (
        // <div style={{ minHeight: '70vh' }}>
        <div className={open ? classes.fundo : classes.altura} >
           <RegisterAccess page={'consultor de funcionario das armed'} />
            {open ?
                <SimpleDialog
                    open={open}
                    onClose={handleClose}
                    admin={admin}
                />
                :
                <Loading text={'A verificar Técnico.'} />
            }
        </div>
    );
}